import { render, staticRenderFns } from "./wageItemFormulaList.vue?vue&type=template&id=2209a238&scoped=true&"
import script from "./wageItemFormulaList.vue?vue&type=script&lang=js&"
export * from "./wageItemFormulaList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2209a238",
  null
  
)

export default component.exports